<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-21 14:27:03
 * @Description: tooltip组件
-->
<template>
  <el-tooltip :effect="effect" :placement="placement" :disabled="disabled" :open-delay="openDelay">
    <div slot="content">
      <slot name="content"></slot>
    </div>
    <slot name="icon"></slot>
  </el-tooltip>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsTooltip',
  componentName: 'LsTooltip',
  mixins: [mixin],
  props: {
    effect: {
      type: String,
      default: 'dark',
      validator: (val) => ['dark', 'light'].includes(val),
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDelay: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>